module.exports = __webpack_public_path__ + "img/img-58.2b901ab3.png";